import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import EntityTags from './EntityTags';
import { Wrapper, Title, Entities } from './styled';
import { get } from 'lodash';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const TagsSection = ({ data }) => {
  const hasTagsFeature = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));
  const hostTag = get(data, 'host_tag', []);
  const vulnTag = get(data, 'vuln_tag', []);
  const servicetag = get(data, 'service_tag', []);
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'agents.triggerAgent.tags.title' });

  if (!hasTagsFeature) return null;

  return (
    <Wrapper>
      <Title children={ title } />
      <Entities>
        <EntityTags entity="assets" values={ hostTag } />
        <EntityTags entity="vulnerabilities" values={ vulnTag } />
        <EntityTags entity="services" values={ servicetag } />
      </Entities>
    </Wrapper>
  );
};

export default TagsSection;
